import SliceContainer from 'containers/slices/SliceContainer';
import { useChargePackageData } from 'hooks/useChargePackageData';
import { PageSlicesCharge_Package_Cta_Large } from 'prismic-types';

import styles from '../PowerPackageCtaLarge/PowerPackageCtaLarge.module.scss';
import PowerPackageCard from 'components/power-package-card/PowerPackageCard';

/**
 * Props for `ChargePackageCtaLarge`.
 */
export type ChargePackageCtaLargeProps = {
  title?: string;
};

/**
 * Component for "ChargePackageCtaLarge" Slices.
 */
export const ChargePackageCtaLarge = ({
  title,
}: ChargePackageCtaLargeProps): JSX.Element => {
  const { chargePackageData } = useChargePackageData();

  return (
    <SliceContainer className={styles.chargePackageCtaLargeWrapper}>
      {title && <h2 className={styles.title}>{title}</h2>}
      <div className={styles.chargePackageCtaLargeTiles}>
        {chargePackageData?.allCharge_packages.edges.map((edge, index) => {
          return (
            <PowerPackageCard
              key={`chargePackageCard-${index}`}
              item={edge.node}
              isChargePackage
            />
          );
        })}
      </div>
    </SliceContainer>
  );
};

export function prismicSliceToChargePackageCtaLarge(
  s: PageSlicesCharge_Package_Cta_Large
) {
  const title = s.variation?.primary?.charge_title || '';
  return <ChargePackageCtaLarge title={title} />;
}
